import React from 'react';
import PropTypes from 'prop-types';

const IconTrendPoorIndicator = ({ width = '16', height = '16', viewBox = '0 0 16 16' }) => {
    return <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox={viewBox} fill='none'>
        <rect y='0.5' width='16' height='16' fill='#EF3A34'/>
        <path d='M12.7652 9.55056L11.0037 2.97656L4.42969 4.73806L4.9101 6.53097L8.49591 5.57015L4.12091 13.1479L5.63646 14.0229L10.0115 6.44515L10.9723 10.031L12.7652 9.55056Z' fill='white'/>
    </svg>;
};

IconTrendPoorIndicator.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string
};

export default React.memo(IconTrendPoorIndicator);
